import { render, staticRenderFns } from "./singleSourceRisk.vue?vue&type=template&id=a533c110&scoped=true"
import script from "./singleSourceRisk.vue?vue&type=script&lang=js"
export * from "./singleSourceRisk.vue?vue&type=script&lang=js"
import style0 from "./singleSourceRisk.vue?vue&type=style&index=0&id=a533c110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a533c110",
  null
  
)

export default component.exports